export class CalendarEventRequestModel {
    constructor() {
        this.startDateAsString = "";
        this.endDateAsString = "";
    }
}
export default class CalendarEventRequest extends CalendarEventRequestModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
